(function () {
  const SCOPE_SELECTOR = '.cm-grid-4';
  const BADGE_CLASS = 'price_percent_off';

  function parseMoney(text) {
    if (!text) return null;
    const m = text.replace(/,/g, '').match(/(\d+(\.\d+)?)/g);
    if (!m || !m.length) return null;
    return parseFloat(m[m.length - 1]);
  }

  function findWasEl(container) {
    // most themes use <s> for compare-at
    return (
      container.querySelector('.price_was') ||
      container.querySelector('s') ||
      container.querySelector('[data-compare-at]') ||
      null
    );
  }

  function findCurrentEl(nearbyContainer) {
    return (
      nearbyContainer.querySelector('.price_current') ||
      nearbyContainer.querySelector('strong') ||
      nearbyContainer.querySelector('[data-price]') ||
      null
    );
  }

  function addBadgeWithin(card) {
    // find a "was" in this card
    const wasEl = findWasEl(card);
    if (!wasEl) return;

    // use the nearest price container around wasEl
    const priceRow = wasEl.closest('.price, .price__default, .price_default, .card__price, .product-card__price') || wasEl.parentElement;
    if (!priceRow) return;

    // avoid duplicates
    if (priceRow.querySelector(`.${BADGE_CLASS}`)) return;

    const currentEl = findCurrentEl(priceRow);
    if (!currentEl) return;

    const was = parseMoney(wasEl.textContent);
    const current = parseMoney(currentEl.textContent);

    if (!was || !current || was <= current) return;

    const percent = Math.round(((was - current) / was) * 100);
    if (!percent || percent < 1) return;

    const badge = document.createElement('span');
    badge.className = BADGE_CLASS;
    badge.textContent = `${percent}% OFF`;
    wasEl.insertAdjacentElement('afterend', badge);
  }

  function scan(scope) {
    // try common card wrappers; if unknown, just scan list items
    const cards =
      scope.querySelectorAll('product-card, .card, .card__inner, li, .product, .grid__item');

    cards.forEach(addBadgeWithin);
  }

  function observe(scope) {
    scan(scope);

    let queued = false;
    const pending = new Set();

    const flush = () => {
      queued = false;
      pending.forEach((node) => {
        if (!(node instanceof Element)) return;
        // if new nodes include cards, scan inside them
        scan(scope);
      });
      pending.clear();
    };

    const obs = new MutationObserver((mutations) => {
      for (const m of mutations) m.addedNodes.forEach((n) => pending.add(n));
      if (!queued) {
        queued = true;
        requestAnimationFrame(flush);
      }
    });

    obs.observe(scope, { childList: true, subtree: true });
  }

  function init() {
    const scope = document.querySelector(SCOPE_SELECTOR);
    if (!scope) return;
    observe(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();